module.exports = __webpack_public_path__ + "static/banner_action_tablet-ed6606d3a7cd18f79b99dee5689580bb.png";